var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { UserDeviceService } from '~/services/management-service/user-device.service';
import { Emit } from 'vue-property-decorator';
var BatchFacility = /** @class */ (function (_super) {
    __extends(BatchFacility, _super);
    function BatchFacility() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeName = 'pcTable';
        _this.pc = {
            data: [],
            selectionList: [],
        };
        _this.moving = {
            data: [],
            selectionList: [],
        };
        return _this;
    }
    BatchFacility.prototype.refreshList = function () { };
    BatchFacility.prototype.refresh = function (arr) {
        var allArr = [];
        arr.forEach(function (v) {
            var arr = v.userDevices.map(function (val) {
                val.userName = v.userName;
                val.userId = v.id;
                return val;
            });
            allArr = allArr.concat(arr);
        });
        this.moving.data = allArr.filter(function (v) { return v.type === 1; });
        this.pc.data = allArr.filter(function (v) { return v.type === 0; });
    };
    /**
     * 启用禁用设备
     */
    BatchFacility.prototype.hangleFacility = function (type, handle) {
        var _this = this;
        this.$confirm("\u60A8\u786E\u5B9A\u8981\u6267\u884C\u8BE5\u64CD\u4F5C\u5417\uFF1F", '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }).then(function () {
            var userIds = [];
            userIds = type === 0 ? _this.pc.selectionList : _this.moving.selectionList;
            _this.userDeviceService
                .disableDevice({
                userIds: userIds.map(function (v) { return v.userId; }),
                usdeType: type,
                validate: 0,
                usdeStatus: handle,
            })
                .subscribe(function (data) {
                userIds.forEach(function (v) {
                    if (v.type === type) {
                        v.status = handle;
                    }
                });
                // 更新数据信息
                _this.$message.success('操作成功');
            }, function (_a) {
                var msg = _a.msg;
            });
        });
    };
    /**
     * 启用停用设备锁
     */
    BatchFacility.prototype.hangleLock = function (type, handle) {
        var _this = this;
        if (this.pc.selectionList.length === 0 &&
            this.moving.selectionList.length === 0) {
            this.$message({
                type: 'warning',
                message: '请选择用户!',
            });
            return;
        }
        this.$confirm("\u60A8\u786E\u5B9A\u8981\u6267\u884C\u8BE5\u64CD\u4F5C\u5417\uFF1F", '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }).then(function () {
            var userIds = [];
            userIds = type === 0 ? _this.pc.selectionList : _this.moving.selectionList;
            _this.userDeviceService
                .enableDeviceKey({
                userIds: userIds.map(function (v) { return v.userId; }),
                usdeType: type,
                validate: handle,
                usdeStatus: handle,
            })
                .subscribe(function (data) {
                userIds.forEach(function (v) {
                    if (v.type === type) {
                        v.validate = handle;
                    }
                });
                // 更新数据信息
                _this.$message({
                    type: 'success',
                    message: '操作成功!',
                });
            }, function (_a) {
                var msg = _a.msg;
            });
        });
    };
    /**
     * 重置设备
     */
    BatchFacility.prototype.resetfacility = function (type) {
        var _this = this;
        this.$confirm("\u60A8\u786E\u5B9A\u8981\u6267\u884C\u8BE5\u64CD\u4F5C\u5417\uFF1F", '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }).then(function () {
            var userIds = [];
            userIds = type === 0 ? _this.pc.selectionList : _this.moving.selectionList;
            _this.userDeviceService
                .resetDevice({
                userIds: userIds.map(function (v) { return v.userId; }),
                usdeType: type,
                validate: 0,
                usdeStatus: 0,
            })
                .subscribe(function (data) {
                // 更新数据信息
                userIds.forEach(function (v) {
                    if (v.type === type) {
                        v.code = '';
                    }
                });
                _this.refreshList();
                _this.$message({
                    type: 'success',
                    message: '操作成功!',
                });
            }, function (_a) {
                var msg = _a.msg;
            });
        });
    };
    __decorate([
        Dependencies(UserDeviceService)
    ], BatchFacility.prototype, "userDeviceService", void 0);
    __decorate([
        Emit('refreshList')
    ], BatchFacility.prototype, "refreshList", null);
    BatchFacility = __decorate([
        Component({
            components: {},
        })
    ], BatchFacility);
    return BatchFacility;
}(Vue));
export default BatchFacility;
